// src/components/common/OverlaySpinner.tsx
import React from 'react';
import { Spin } from 'antd';

interface OverlaySpinnerProps {
    tip?: string;
}

const OverlaySpinner: React.FC<OverlaySpinnerProps> = ({ tip = "Выполняется вычисление..." }) => (
    <div
        style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
        }}
    >
        <Spin tip={tip} size="large" />
    </div>
);

export default OverlaySpinner;
